import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export default function Empty() {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col justify-center items-center h-[80vh]">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
            >
                <g clip-path="url(#clip0_1183_29628)">
                    <path
                        d="M4 4C4.24493 4.00003 4.48134 4.08996 4.66437 4.25272C4.84741 4.41547 4.96434 4.63975 4.993 4.883L5 5V18H20C20.2549 18.0003 20.5 18.0979 20.6854 18.2728C20.8707 18.4478 20.9822 18.687 20.9972 18.9414C21.0121 19.1958 20.9293 19.4464 20.7657 19.6418C20.6021 19.8373 20.3701 19.9629 20.117 19.993L20 20H4C3.75507 20 3.51866 19.91 3.33563 19.7473C3.15259 19.5845 3.03566 19.3603 3.007 19.117L3 19V5C3 4.73478 3.10536 4.48043 3.29289 4.29289C3.48043 4.10536 3.73478 4 4 4ZM20.194 6.818C21.094 6.818 21.544 7.906 20.908 8.542L15.338 14.112C15.1317 14.3181 14.8521 14.4339 14.5605 14.4339C14.2689 14.4339 13.9893 14.3181 13.783 14.112L11.025 11.354L7.49 14.889C7.30249 15.0766 7.04812 15.1821 6.78285 15.1822C6.51758 15.1823 6.26314 15.077 6.0755 14.8895C5.88786 14.702 5.78239 14.4476 5.7823 14.1824C5.7822 13.9171 5.88749 13.6626 6.075 13.475L10.247 9.303C10.3492 9.2008 10.4704 9.11973 10.6039 9.06442C10.7374 9.0091 10.8805 8.98063 11.025 8.98063C11.1695 8.98063 11.3126 9.0091 11.4461 9.06442C11.5796 9.11973 11.7008 9.2008 11.803 9.303L14.561 12.061L17.803 8.818H17.389C17.1238 8.818 16.8694 8.71264 16.6819 8.52511C16.4944 8.33757 16.389 8.08322 16.389 7.818C16.389 7.55278 16.4944 7.29843 16.6819 7.11089C16.8694 6.92336 17.1238 6.818 17.389 6.818H20.194Z"
                        fill="#4C4C4C"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_1183_29628">
                        <rect width="24" height="24" fill="white" />
                    </clipPath>
                </defs>
            </svg>
            <p className="text-[#4C4C4C] text-base mb-4 mt-3">
                {t('No Open Positions')}
            </p>
            <Link
                to={'/future'}
                className="px-8 py-3 rounded-full bg-white text-black mb-10 font-medium"
            >
                {t('Trade Now')}
            </Link>
        </div>
    );
}
